import './styles/global.css'
import './styles/forms.css'

import App from './components/app'

export default App
